import { Component, OnInit } from '@angular/core';
import { GeneralComponent } from '../../General/g.component';
import { AppService } from '../app.service';

@Component({
  selector: 'app-t-topics',
  templateUrl: './t-topics.component.html',
  styleUrls: ['../../General/tiles.css', './t-topics.component.css']
})
export class TTopicsComponent  implements OnInit {

  constructor(protected appService: AppService) {
  }

  ngOnInit() {
  }

  /** get text in right language
  * @param {string} tag - text to load
  */
 get(tag: string): String {
   return this.appService.get(tag);
  }

}
